/**
 * @generated SignedSource<<dd8b10e8f0736ae4ebaefbc5445c6f4a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type attachmentItems_AtlassianSearchPage_DropdownItems$data = {
  readonly entity: {
    readonly attachments?: ReadonlyArray<{
      readonly mimeType: string | null | undefined;
      readonly thumbnailUrl: string | null | undefined;
      readonly title: string | null | undefined;
      readonly url: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly lastModifiedDate: string | null | undefined;
  readonly " $fragmentType": "attachmentItems_AtlassianSearchPage_DropdownItems";
};
export type attachmentItems_AtlassianSearchPage_DropdownItems$key = {
  readonly " $data"?: attachmentItems_AtlassianSearchPage_DropdownItems$data;
  readonly " $fragmentSpreads": FragmentRefs<"attachmentItems_AtlassianSearchPage_DropdownItems">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "attachmentItems_AtlassianSearchPage_DropdownItems",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "ExternalAttachment",
              "kind": "LinkedField",
              "name": "attachments",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "title"
                },
                {
                  "kind": "ScalarField",
                  "name": "mimeType"
                },
                {
                  "kind": "ScalarField",
                  "name": "url"
                },
                {
                  "kind": "ScalarField",
                  "name": "thumbnailUrl"
                }
              ]
            }
          ],
          "type": "ExternalMessage"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};

(node as any).hash = "1d0a13f92b4b1c1eecb3772e0ddae100";

export default node;
